export default __webpack_public_path__ + "static/media/zoi-fintech-services.5ef64e3c.png";